import { Container, Button, Card, Image } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { MdWhatsapp } from "react-icons/md";
import "./styles.scss";

import { getAllPartiners } from "../../services/api";
import Brand from "../../assets/img/os3.jpeg";

const PIXEL_ID = "1685019248686918";

export default function Grupos() {
    const [partners, setPartners] = useState([]);
    const [countdown, setCountdown] = useState(null);
    const baseURL =
        process.env.NODE_ENV === "production"
            ? process.env.REACT_APP_MERCADIM_BASE_URL_PRO
            : process.env.REACT_APP_MERCADIM_BASE_URL_DEV;
    useEffect(() => {
        getAllPartiners().then(setPartners);

        const targetDate = new Date("2025-11-28T00:00:00").getTime();

        const timer = setInterval(() => {
            const now = new Date().getTime();
            const distance = targetDate - now;

            if (distance <= 0) {
                setCountdown("🎉 É HOJE! A Black Friday chegou 🔥");
                clearInterval(timer);
            } else {
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor(
                    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                );
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                const format = (n) => n.toString().padStart(2, "0");

                setCountdown(
                    `⏰ Virada da Black Friday: ${days} dias ${format(hours)}:${format(
                        minutes
                    )}:${format(seconds)}`
                );
            }
        }, 1000);

        if (typeof window !== "undefined") {
            if (!window.fbq) {
                (function (f, b, e, v, n, t, s) {
                    if (f.fbq) return;
                    n = f.fbq = function () {
                        if (n.callMethod) {
                            n.callMethod.apply(n, arguments);
                        } else {
                            n.queue.push(arguments);
                        }
                    };
                    if (!f._fbq) f._fbq = n;
                    n.push = n;
                    n.loaded = true;
                    n.version = "2.0";
                    n.queue = [];
                    t = b.createElement(e);
                    t.async = true;
                    t.src = v;
                    s = b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t, s);
                })(
                    window,
                    document,
                    "script",
                    "https://connect.facebook.net/en_US/fbevents.js"
                );
            }

            const fbq = window.fbq;

            if (typeof fbq === "function") {
                if (!window.fbqInitialized) {
                    fbq("init", PIXEL_ID);
                    window.fbqInitialized = true;
                }

                fbq("track", "PageView");
            }
        }

        return () => clearInterval(timer);
    }, []);

    return (
        <>
            <Helmet>
                <title>Grupos de Ofertas - Black Friday</title>
                <noscript>{`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1" alt="Facebook Pixel" />`}</noscript>
            </Helmet>
            <Container className="text-center my-5 grupos-wrapper pt-5 mt-5">
                <Image
                    src={Brand}
                    width={120}
                    alt="Foto Jersu"
                    className="mb-3"
                    roundedCircle
                />

                <h2 className="fw-bold black-friday-countdown">
                    {countdown || "..."}
                </h2>

                <p className="text-muted">
                    Estamos a mais de 5 anos ajudando milhares de pessoas a economizar!
                </p>

                <div className="d-flex flex-column align-items-center gap-3 mt-4">
                    <Card className="grupo-card whatsapp">
                        <Card.Body className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                            <div className="d-flex align-items-center gap-3">
                                <MdWhatsapp size={30} color="#25D366" />
                                <div className="text-start">
                                    <small className="text-muted">Entre no grupo de WhatsApp</small>
                                    <br />
                                    <strong>40.000 membros</strong>
                                </div>
                            </div>
                            <Button
                                as="a"
                                href={`${baseURL}entrar?tipo=ofertas`}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant="success"
                                className="join-button"
                            >
                                Entrar
                            </Button>
                        </Card.Body>
                    </Card>
                </div>

                {partners.length > 0 && (
                    <>
                        <hr className="my-5" />
                        <h6 className="text-muted">Conexões diretas com</h6>
                        <div className="store-logos-container d-flex justify-content-center flex-wrap gap-3 mt-3">
                            {partners.map((partner, index) => (
                                <Link
                                    key={index}
                                    to={`/loja/${partner.slug}`}
                                    className="store-logo-link"
                                >
                                    <Image
                                        src={partner.image_url}
                                        alt={partner.name}
                                        className="store-logo"
                                        width={40}
                                        height={40}
                                        roundedCircle
                                    />
                                </Link>
                            ))}
                        </div>
                    </>
                )}
            </Container>
        </>
    );
}